module.exports = __webpack_public_path__ + "img/logo_gki.3e0feae0.png";